var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column align-items-center"},[_c('personal-user',{staticStyle:{"width":"40em"},attrs:{"disableEmail":true},model:{value:(_vm.user),callback:function ($$v) {_vm.user=$$v},expression:"user"}}),_vm._v(" "),_c('btn-action',{staticClass:"btn btn-primary",on:{"click":_vm.save}},[_vm._v("Сохранить")])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b7d9180","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/personal/index.vue
// module id = null
// module chunks = 